<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { copyToClipboard } from "@common/Common";
    import { ScoringPanelistReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";
    import { ScoringSurveyAccessLinksViewModel } from "@Evaluation/AlternativesSurveys/Components/ScoringSurveyAccessLinks";


@Component({
    props: {
        viewModel: { type: Object, required: true }
    }
})
export default class ScoringSurveyAccessLinks extends Vue
{
    get vm(): ScoringSurveyAccessLinksViewModel { return this.$props.viewModel as ScoringSurveyAccessLinksViewModel; }
    get opened(): boolean { return this.vm?.opened ?? false; }

    get initialized(): boolean { return this.vm.data != null; }
    get surveyId(): number { return this.vm.surveyId; }
    get panelists(): ScoringPanelistReadModel[] { return this.vm.data.Panelists; }

    copyAccessUrlToClipboard(pu: ScoringPanelistReadModel)
    {
        copyToClipboard(pu.AccessUrl);

        let url = pu.AccessUrl;
        pu.AccessUrl = "Copied to clipboard";

        let handle = setTimeout(() =>
        {
            pu.AccessUrl = url;
            clearTimeout(handle);
        }, 500);
    }

    downloadLinks()
    {
        this.$emit("download-links", this.surveyId);
    }

    emailOne(vm: ScoringPanelistReadModel)
    {
        this.$emit("show-email-sender", this.surveyId, [vm.ProjectUserId]);
    }

    emailAll()
    {
        this.$emit("show-email-sender", this.surveyId, this.panelists.map(a => a.ProjectUserId));
    }

    close()
    {
        this.vm.close();
    }
}
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Access links</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h3 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>

                        <div v-if="initialized">
                            <table class="table table-hover">
                                <thead class="thead-light">
                                    <tr>
                                        <th>
                                            Panelist
                                        </th>
                                        <th>
                                            Access link
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="p in panelists" :key="p.ProjectUserId">
                                        <td>
                                            <span>{{p.Name}}</span><br />
                                            <span class="text-muted" v-if="p.HasEmail">{{p.Email}}</span>
                                            <span class="text-danger" v-if="!p.HasEmail">Email not provided</span>
                                        </td>
                                        <td class="align-middle">
                                            <div class="input-group">

                                                <input type="text" class="form-control" readonly v-model="p.AccessUrl" />
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary" type="button" title="Copy to clipboard" @click="copyAccessUrlToClipboard(p)">
                                                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                                                    </button>
                                                    <button class="btn btn-outline-secondary" type="button" title="Send link via email" :disabled="!p.HasEmail" @click="emailOne(p)">
                                                        <i class="fa-regular fa-envelope"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div class="modal-footer">
                        <button @click="downloadLinks" :disabled="!initialized" type="button" class="btn btn-outline-secondary">Download links</button>
                        <button @click="emailAll" :disabled="!initialized" type="button" class="btn btn-outline-secondary">Email all</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>